import React from 'react';
import { Modal } from 'reactstrap';

const ConfirmationModal = props => (
    <Modal isOpen={props.isOpen} size="md" toggle={props.onToggle}>
        {props.children}
    </Modal>
);

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/components/common/ConfirmationModal.js